import type { GenericRequest } from '@eliadmin/core/src/api/api-types';
import { buildAuthHeader, fetchData } from '@eliadmin/core/src/api/fetcher';

/**
 * `fileId` comes from the generic /store/files upload endpoint (see uploadFile
 * in general-api.ts) - the xlsx is uploaded there first, then its id is passed here.
 */
export const importVehiclesFile = async ({
  locale,
  authToken,
  fileId,
}: GenericRequest<{ authToken: string; fileId: number }>) =>
  fetchData<{ message?: string }>({
    method: 'POST',
    uri: `/store/vehicles/import/${fileId}`,
    locale,
    headers: buildAuthHeader(authToken),
  });
